"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CovidDiseaseEducationBrand = void 0;
exports.CovidDiseaseEducationBrand = {
    "color-brand-education-covid-50": "#F2F2FB",
    "color-brand-education-covid-100": "#E7E7F8",
    "color-brand-education-covid-200": "#D4D3F2",
    "color-brand-education-covid-300": "#B9B7EA",
    "color-brand-education-covid-400": "#A39ADF",
    "color-brand-education-covid-500": "#9081D3",
    "color-brand-education-covid-600": "#8167C4",
    "color-brand-education-covid-700": "#6F57AB",
    "color-brand-education-covid-800": "#544381",
    "color-brand-education-covid-900": "#3B2C6A",
    "color-brand-education-covid-950": "#1E2846"
};
//# sourceMappingURL=CovidDiseaseEducationBrand.js.map